import axios from 'axios'

/**
 * Private documents (geran, signed DO...) are served by the API at
 * /api/files/{media_id}/{file_name} and only to the signed-in customer of that order, so they
 * are fetched with the login. Public files keep their open links and load as before.
 */
export const isPrivateFileUrl = (url) =>
  typeof url === 'string' && /\/api\/files\/\d+\/[^/]+$/.test(url.split('?')[0])

export async function loadFileBlob(url) {
  if (isPrivateFileUrl(url)) {
    const token = localStorage.getItem('token')
    const res = await axios.get(url, {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    return res.data
  }
  const res = await fetch(url)
  if (!res.ok) {
    throw new Error(`Failed to fetch: ${res.status} ${res.statusText}`)
  }
  return res.blob()
}
